export type GtmData = {
  event:string
  customEventCategory: string
  customEventAction: string
  customEventLabel: string
} | {
    event:string
    customEventCategory: string
    appStore: string
    detail: string
}

// 퍼포먼스 트래킹 코드 전송 (GTM 360 등)
export const pushGtmCustomEvent = (paylaod: GtmData) => {
  console.log('GTM: ', paylaod);

  // 유저가 쿠키레이어에서 '퍼포먼스' 쿠키 사용 동의를 허용했거나, 한국어 인경우, 바닦에 window._pushGtmCustomEvent 가 존재 한다. (운영툴에서 세팅)
  window._pushGtmCustomEvent && window._pushGtmCustomEvent(paylaod);
};

// 마케팅 트래킹 코드 전송
export const pushMarkettingTracking = (idx: number) => {
  // 유저가 쿠키레이어에서 '마케팅' 쿠키 사용 동의를 허용했거나, 한국어 인경우, 바닦에 window._successPreorderReservation 가 존재 한다. (운영툴에서 세팅)
  window._successPreorderReservation && window._successPreorderReservation(idx);
};

// googleplay : 1, AppStore : 2, galaxystore : 3, onestore : 4, else: 1
export const getGtmSuccessPreorder = ({appstore, lang, service, alias}: {appstore:string, lang:string, service:string, alias:string}):  GtmData => ({
    'event': 'customEvent',
    'customEventCategory': '사전예약',
    'appStore': `${ (appstore === '1' && 'Googleplay') || (appstore === '2' && 'Appstore') || (appstore === '3' && 'Galaxstore') || (appstore === '4' && 'Onestore') || '미설정' }`,
    'detail': `${lang}_${service}_${alias}`
});

export const getGtmTopBanner = (title: string):  GtmData  => ({
  'event': 'customEvent',
  'customEventCategory': '클릭',
  'customEventAction': '배너 영역 - 버튼 클릭',
  'customEventLabel': `클릭 컨텐츠 : ${title}`
});

export const getGtmHome = ():  GtmData  => ({
  'event': 'customEvent',
  'customEventCategory': '클릭',
  'customEventAction': 'Content Container - 버튼 클릭',
  'customEventLabel': `클릭 컨텐츠 : 브랜드 홈`
});

export const getGtmBi = ():  GtmData  => ({
  'event': 'customEvent',
  'customEventCategory': '클릭',
  'customEventAction': 'Header - 버튼 클릭',
  'customEventLabel': `클릭 컨텐츠 : BI`
});

export const getGtmReward = (desc: string):  GtmData  => ({
  'event': 'customEvent',
  'customEventCategory': '클릭',
  'customEventAction': 'Content Container  - 버튼 클릭',
  'customEventLabel': `클릭 컨텐츠 : reward(${desc})`
});

export const getGtmGoNextStep = ():  GtmData  => ({
  'event': 'customEvent',
  'customEventCategory': '클릭',
  'customEventAction': 'Content Container - 버튼 클릭',
  'customEventLabel': '클릭 컨텐츠 : 사전예약하기'
});

export const getGtmCouponeReg = (name: string) :  GtmData => ({
  'event': 'customEvent',
  'customEventCategory': '클릭',
  'customEventAction': 'Content Container - 버튼 클릭',
  'customEventLabel': `클릭 컨텐츠 : 쿠폰등록{${name.replaceAll(/[^\wㄱ-힣]/g,'')}}`
});

export const getGtmExtraBtn = ():  GtmData  => ({
  'event': 'customEvent',
  'customEventCategory': '클릭',
  'customEventAction': 'Content Container - 버튼 클릭',
  'customEventLabel': '클릭 컨텐츠 : 추가 클릭'
});

export const getGtmCouponSearch = () :  GtmData => ({
  'event': 'customEvent',
  'customEventCategory': '클릭',
  'customEventAction': '쿠폰조회 기간 - 버튼 클릭',
  'customEventLabel': '클릭 컨텐츠 : button'
});

export const getGtmLauncher = () :  GtmData => ({
  'event': 'customEvent',
  'customEventCategory': '클릭',
  'customEventAction': '배너 영역 - 버튼 클릭',
  'customEventLabel': '클릭 컨텐츠 : NC Launcher 2 다운로드'
});

export const getGtmGoEvent = () :  GtmData => ({
  'event': 'customEvent',
  'customEventCategory': '클릭',
  'customEventAction': 'Content Container - 버튼 클릭',
  'customEventLabel': '클릭 컨텐츠 : 이벤트 바로가기'
});
